import type { PatientStrings } from '../index';

export const ml: PatientStrings = {
  titleOne: 'നിങ്ങളുടെ പുതിയ ക്രൗൺ',
  titleMany: 'നിങ്ങളുടെ പുതിയ ക്രൗണുകൾ',
  tooth: 'പല്ല്',
  teeth: 'പല്ലുകൾ',
  both: 'രണ്ടും',
  overview: 'മുഴുവൻ കാഴ്ച',
  front: 'മുന്നിൽ നിന്ന്',
  leftSide: 'ഇടത് വശം',
  rightSide: 'വലത് വശം',
  bitingSurface: 'ചവയ്ക്കുന്ന ഭാഗം',
  show: 'കാണിക്കുക',
  newCrown: 'പുതിയ ക്രൗൺ',
  newCrowns: 'പുതിയ ക്രൗണുകൾ',
  yourTeeth: 'നിങ്ങളുടെ പല്ലുകളും മോണയും',
  upperTeeth: 'മുകളിലെ പല്ലുകൾ',
  lowerTeeth: 'താഴത്തെ പല്ലുകൾ',
  hint: 'തിരിക്കാൻ വലിക്കുക · സൂം ചെയ്യാൻ പിഞ്ച് അല്ലെങ്കിൽ സ്ക്രോൾ ചെയ്യുക',
  zoomIn: 'അടുത്ത്',
  zoomOut: 'അകലെ',
  turnSlowly: 'പതുക്കെ തിരിക്കുക',
  stopTurning: 'തിരിക്കൽ നിർത്തുക',
  backToStart: 'തുടക്കത്തിലേക്ക്',
  fullScreen: 'പൂർണ്ണ സ്ക്രീൻ',
  exitFullScreen: 'പൂർണ്ണ സ്ക്രീനിൽ നിന്ന് പുറത്ത്',
  fromDentist: 'നിങ്ങളുടെ ദന്ത ഡോക്ടറിൽ നിന്ന്',
  shadeNote: (shade) =>
    `നിറം ഏകദേശം ഷേഡ് ${shade} പോലെയാണ് കാണിച്ചിരിക്കുന്നത്. യഥാർത്ഥ ക്രൗണിന്റെ നിറം ലാബിൽ ഒത്തുനോക്കുന്നു.`,
  before: 'മുമ്പ്',
  after: 'ശേഷം',
  seeInRoom: 'നിങ്ങളുടെ മുറിയിൽ കാണുക',
  arNotSupported: 'ക്രൗൺ നിങ്ങളുടെ മുറിയിൽ കാണാൻ ഈ പേജ് ഫോണിൽ തുറക്കുക.',
  appointmentTitle: 'ക്രൗൺ ഘടിപ്പിക്കുന്ന നിങ്ങളുടെ അപ്പോയിന്റ്മെന്റ്',
  confirm: 'സ്ഥിരീകരിക്കുക',
  confirmed: 'സ്ഥിരീകരിച്ചു — അപ്പോൾ കാണാം',
  anotherTime: 'മറ്റൊരു സമയം ചോദിക്കുക',
  anotherTimeSent: 'നിങ്ങൾക്ക് മറ്റൊരു സമയം വേണമെന്ന് ദന്ത ഡോക്ടറെ അറിയിച്ചിട്ടുണ്ട്.',
  language: 'ഭാഷ',
  largerText: 'വലിയ അക്ഷരം',
};
